/**
 * Menu Accessibility - Keyboard Navigation for Dropdowns
 * Handles keyboard navigation (Tab, Enter, Space, Escape, Arrow keys)
 */

export function initMenuAccessibility() {
    // Navigation dropdowns
    const navToggles = document.querySelectorAll('.c-navigation__dropdown-toggle');
    navToggles.forEach(initDropdownToggle);

    // Language selector
    const langToggle = document.querySelector('.c-languages__toggle');
    if (langToggle) {
        initDropdownToggle(langToggle);
    }
}

function initDropdownToggle(toggle) {
    const parent = toggle.closest('.c-navigation__list-item, .c-languages');
    const dropdown = parent?.querySelector('.c-dropdown, .c-languages__list');

    if (!dropdown) return;

    // Toggle on click
    toggle.addEventListener('click', function(e) {
        e.preventDefault();
        toggleDropdown(toggle, dropdown);
    });

    // Toggle on Enter/Space
    toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleDropdown(toggle, dropdown);
        } else if (e.key === 'Escape') {
            closeDropdown(toggle, dropdown);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            openDropdown(toggle, dropdown);
            focusFirstMenuItem(dropdown);
        }
    });

    // Handle keyboard navigation inside dropdown
    const menuItems = dropdown.querySelectorAll('a[role="menuitem"]');
    menuItems.forEach((item, index) => {
        item.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                closeDropdown(toggle, dropdown);
                toggle.focus();
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextItem = menuItems[index + 1];
                if (nextItem) nextItem.focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (index === 0) {
                    toggle.focus();
                } else {
                    menuItems[index - 1].focus();
                }
            } else if (e.key === 'Home') {
                e.preventDefault();
                menuItems[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                menuItems[menuItems.length - 1].focus();
            }
        });
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
        if (!parent.contains(e.target)) {
            closeDropdown(toggle, dropdown);
        }
    });

    // Close on focus leave
    parent.addEventListener('focusout', function(e) {
        // Check if focus moved outside the parent
        setTimeout(() => {
            if (!parent.contains(document.activeElement)) {
                closeDropdown(toggle, dropdown);
            }
        }, 10);
    });
}

function toggleDropdown(toggle, dropdown) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
        closeDropdown(toggle, dropdown);
    } else {
        openDropdown(toggle, dropdown);
    }
}

function openDropdown(toggle, dropdown) {
    toggle.setAttribute('aria-expanded', 'true');
    dropdown.classList.add('is-open');
    dropdown.style.display = 'block';
}

function closeDropdown(toggle, dropdown) {
    toggle.setAttribute('aria-expanded', 'false');
    dropdown.classList.remove('is-open');
    dropdown.style.display = '';
}

function focusFirstMenuItem(dropdown) {
    const firstItem = dropdown.querySelector('a[role="menuitem"]');
    if (firstItem) {
        setTimeout(() => firstItem.focus(), 50);
    }
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuAccessibility);
} else {
    initMenuAccessibility();
}

